/**
 *  Import vendor JS
 *
 */

/**
 *  Import local Js
 *
 */

import '@babel/polyfill';

import { lazyLoader } from './modules/Helpers';
import LoadMore from './modules/LoadMore';
import MastheadSearch from './modules/MastheadSearch';
// import PostPicker from './modules/PostPicker';

LoadMore('.c-buttoncta--loadmore');
// PostPicker();
lazyLoader();
MastheadSearch();

import './modules/Polyfill-forEach';
